"use client";

import { Button } from "@/components/ui/button";
import { getCommonZendeskUrl } from "@/constants/zendesk-urls/common-zendesk-urls";
import dynamic from "next/dynamic";
import { useCookieConsent } from "./use-cookie-consent";

function CookieConsentBannerImpl() {
  const { available, consent, grant, deny } = useCookieConsent();
  const cookiePolicyUrl = getCommonZendeskUrl("cookiePolicy");

  if (!available || consent !== null) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-monotone-3 bg-white p-4 shadow-lg">
      <div className="mx-auto flex max-w-4xl items-center justify-between gap-4">
        <div className="text-sm text-monotone-7">
          <p>
            当サイトでは、サイトの利便性向上、サービス改善および利用状況の分析を目的として、Cookieなどを使用する場合があります。取得した情報の一部はアクセス解析ツール等の第三者サービスに送信される場合があります。
          </p>
          <p className="mt-1">
            詳しくは
            <a
              href={cookiePolicyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-6 underline"
            >
              クッキーポリシー
            </a>
            をご確認ください。
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <Button variant="ghost" onClick={deny}>
            拒否する
          </Button>
          <Button variant="primary" onClick={grant}>
            同意する
          </Button>
        </div>
      </div>
    </div>
  );
}

// Cookie同意バナーはlocalStorageの値に依存するため、SSRする意味がない（サーバーが値を知らない）。
// SSRに含めると hydration 前にバナーが一瞬見える問題が出るので、CSR専用で読み込む。
export const CookieConsentBanner = dynamic(
  async () => CookieConsentBannerImpl,
  { ssr: false },
);
